export default {
    public:{
        testCreate:'/test/create',//创建测试
        goonTest:'/test/goon',//继续测试
        setNode:'/test/setNode',//设置节点,
        markOver:'/test/markOver'//完成测评
    },
    rgtx:{ //人格特性
        rgtxList1:'/topic/getMbtiList',
        rgtxSubmit1:'/result/addMbti'
    },
    znsp:{ //智能水平
        yynlList1:'/topic/getLangUnderstandList', //语言能力-语言理解 1.1
        yynlAdd1:'/result/addLangUnderstand',
        yynlList2:'/topic/getLangExpressList', //语言能力-语言表达 1.2
        yynlAdd2:'/result/addLangExpress',

        zrnlList1:'/topic/getNatureRelationList', //自然能力-关系判断 2.1
        zrnlAdd1:'/result/addNatureRelation',
        zrnlList2:'/topic/getNatureCategoryList', //自然能力-类别判断 2.1
        zrnlAdd2:'/result/addNatureCategory',

        kjnlList1:'/topic/getSpaceProportionList', //空间能力-比例判断 3.1
        kjnlAdd1:'/result/addSpaceProportion',
        kjnlList2:'/topic/getSpaceArtList', //空间能力-艺术想象 3.2
        kjnlAdd2:'/result/addSpaceArt',
        kjnlList3:'/topic/getSpaceColorList', //空间能力-色彩对比 3.3
        kjnlAdd3:'/result/addSpaceColor',

        rjnlList1:'/topic/getPeopleOrder', //人际能力-情景排序、情景分析、情景应对 4.1/4.2/4.3
        rjnlList2:'/topic/getPeopleAnalysis',
        rjnlList3:'/topic/getPeopleResponse',
        rjnlAdd1:'/result/addPeopleOrder',
        rjnlAdd2:'/result/addPeopleAnalysis',
        rjnlAdd3:'/result/addPeopleResponse',

        sxnlList1:'/topic/getMathCalculationList', //数学能力-数学运算 5.1
        sxnlAdd1:'/result/addMathCalculation',
        sxnlList2:'/topic/getMathSequenceList', //数学能力-数列推理 5.2
        sxnlAdd2:'/result/addMathSequence',
        sxnlList3:'/topic/getMathLogicList', //数学能力-逻辑推理 5.3
        sxnlAdd3:'/result/addMathLogic',

        kjnlList4:'/topic/getSpaceRepresentList', //空间能力-表象判断 6.1
        kjnlAdd4:'/result/addSpaceRepresent',

        rjnlList4:'/topic/getPeopleMoodList', //人际能力-情绪识别 7.1
        rjnlAdd4:'/result/addPeopleMood',


        stydnlAdd1:'/result/addSpacePosition', //身体运动能力-空间定向 8.1

        stydnlAdd2:'/result/addBodyDiy', //身体运动能力-动手操作 9.1


        yinyuenlList1:'/topic/getMusicList', //音乐能力 10.1
        yinyuenlAdd1:'/result/addMusic',
    },
    xqqx:{ //兴趣倾向
        xqqxList1:'/topic/getHobbyList',
        xqqxAdd:'/result/addHobby'
    },
    zyjzg:{ //职业价值观
        zyjzgList1:'/topic/getProfessionList',
        zyjzgAdd:'/result/addProfession'
    },
    xlsyx:{ //心理适应性
        xlsyxList1:'/topic/getMindList',
        xlsyxAdd:'/result/addMind',
    }
}


